import Component from '../core/Component'
import Scroll from '../services/Scroll'

export const STATES = {
    PINNED: 'is-pinned',
}

export default class SampleSearch extends Component {
    constructor(element,options={}) {
        super(element,options)

        this.ref = {
            sampleHeader: null,
        }

        this.state = {
            headerHeight: null,
            searchBarTop: null
        }
    }
    
    prepare() {
        Scroll.on('scroll', this.handleScroll)
        Scroll.on('resize', this.handleResize)

        this.resize()
    }

    destroy() {
        Scroll.off('scroll', this.handleScroll)
        Scroll.off('resize', this.handleResize)
    }

    handleScroll = ({y}) => {
        const searchBar = this.element.querySelector('.search__bar')
        
        if(y > this.state.searchBarTop - this.state.headerHeight) {
            searchBar.classList.add(STATES.PINNED)
            searchBar.style.top = `${this.state.headerHeight}px`
        } else {
            searchBar.classList.remove(STATES.PINNED)
            searchBar.style.top = '0'
        }
    }

    handleResize = () => {
        this.resize()
    }


    resize() {
        const searchBar = this.element.querySelector('.search__bar')
        this.state.headerHeight = this.ref.sampleHeader.getBoundingClientRect().height
        this.state.searchBarTop = searchBar.getBoundingClientRect().top
    }
}